import { render, staticRenderFns } from "./ConfettiPaper.vue?vue&type=template&id=23245321&scoped=true"
import script from "./ConfettiPaper.vue?vue&type=script&lang=js"
export * from "./ConfettiPaper.vue?vue&type=script&lang=js"
import style0 from "./ConfettiPaper.vue?vue&type=style&index=0&id=23245321&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23245321",
  null
  
)

export default component.exports